import { patientChartTooltipHandler } from "./patientChartTooltip";

const usePatientsChart = (data = []) => {
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    interaction: {
      mode: "index",
      intersect: false,
    },
    plugins: {
      tooltip: {
        enabled: false,
        position: "nearest",
        external: patientChartTooltipHandler,
      },
      legend: {
        position: "bottom",
        labels: {
          boxWidth: 5,
          boxHeight: 5,
          usePointStyle: true,
        },
      },
    },
    scales: {
      x: {
        stacked: true,
      },
      y: {
        stacked: true,
        beginAtZero: true,
        title: {
          display: true,
          text: "No. of Patients",
        },
      },
    },
  };

  const colorPalette = [
    "#94ba33",
    "#5489D8",
    "#FE9859",
    "#134DAA",
    "#A1A1A1",
    "#bdbdbd",
    "#FF6384",
    "#36A2EB",
    "#FFCE56",
    "#4BC0C0",
    "#9966FF",
    "#FF9F40",
  ];

  const datasets = Object?.entries(data)
    ?.filter(([label]) => label !== "manufacturers")
    ?.map(([label, values], index) => ({
      label,
      data: values,
      backgroundColor: colorPalette[index],
      barThickness: 35,
      pointStyle: "circle",
    }));
  const chartData = {
    labels: data?.manufacturers,
    datasets,
  };

  return { options, chartData };
};

export default usePatientsChart;
